import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Overview',
  name: 'wheelLandingOverview',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Subtitle',
      name: 'subtitle',
      type: 'richText',
    }),
    defineField({
      title: 'Features',
      name: 'features',
      type: 'array',
      of: [
        {
          type: 'string',
        },
      ],
    }),
    defineField({
      name: 'video',
      title: 'Video embed',
      type: 'youtubeVideo',
    }),
    defineField({
      name: 'description',
      title: 'Description',
      type: 'richText',
    }),
    defineField({
      title: 'Wheel Carousel',
      name: 'carousel',
      type: 'wheelLandingCarousel',
    }),
  ],
})